import { BACKEND_MESSAGE_TO_ERROR_CODE, EErrorCodes } from '@/lib/consts/errors';
import { HttpError } from '@/lib/http-client/types';

export const getHttpErrorBodyMessage = (error: HttpError): string | undefined => {
    const { data } = error;
    if (typeof data === 'string') {
        return data;
    }
    if (data && typeof data === 'object' && 'message' in data) {
        const message = (data as { message: unknown }).message;
        if (typeof message === 'string') {
            return message;
        }
    }
    return undefined;
};

export const resolveFailedPageErrorFromHttpError = (error: HttpError): EErrorCodes | undefined => {
    const message = getHttpErrorBodyMessage(error);
    if (!message) return undefined;
    return BACKEND_MESSAGE_TO_ERROR_CODE[message];
};
